import * as React from "react";
import { connect } from "react-redux";
import * as types from "../../../../constants/actionTypes";
import { logUI } from "../../../../api/andyliticsApi";
import * as Tools from "../../../../helpers/Tools";
import { queryParams } from "../../../../helpers/formatting";
import { Grid, Radio } from "../../../ecosystem/";
import { CareGapsButtons, CareGapsHeading, CareGapsQuestionHeading } from '../components';
import CareGapsConfirmationModal from "../CareGapsConfirmationModal";
import * as queryString from 'query-string';
import * as constants from "../../../../constants/textConstants";
import Spinner from "../../../common/spinner";

class AnnualWellnessVisitScreening extends React.Component {
    constructor(props) {
        super(props);
        let params = location.search ? queryString.parse(location.search) : {};      
        let stringifiedParams = JSON.stringify(params).toLowerCase();        
        params = JSON.parse(stringifiedParams);        
        const { saveCareGapsSessionId, careGapsSessionId } = this.props;
        this.state = {
            selectedOption: null,
            showModal: false,
            careGapsSessionId: params.sessionid || careGapsSessionId,
            showSpinner: false,
            clickedOnNext: false,
            userHasEpicAccount: true,
            fetchSchedulingPermissionsFailed: false,
        }
        saveCareGapsSessionId(this.state.careGapsSessionId)
    }

    componentDidMount() {
        const { careGapsSessionId } = this.state;
        logUI("MBHWeb.UI.AnnualWellnessVisitScreening.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && { careGapsSessionId: careGapsSessionId }); 
        this.populatePreCheckedSelectOption();
    }

    componentDidUpdate(prevProps) {
        if (this.props.schedulingPermissions !== prevProps.schedulingPermissions ||
            this.props.memberships !== prevProps.memberships) {
            this.fetchSchedulingPermissions();
        }
    }

    populatePreCheckedSelectOption = () => {
        const { selectedCareGapOption } = this.props;
        this.setState({ selectedOption: selectedCareGapOption, showModal: Boolean(selectedCareGapOption) })
    }

    onChangeValue = (event) => {     
        const val = event?.target?.value;  
        this.props.clearFlowData(this.state.careGapsSessionId);
        this.setState({ selectedOption: val, showModal: val !== "No, let’s set one up" }, () => {
            const { careGapsSessionId, selectedOption } = this.state;
            logUI(`MBHWeb.UI.AnnualWellnessVisitScreening.SelectedOption.Clicked`, new Date(), Tools.getURLPath(), { selectedOption, ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
            }
            );        
    }

    handleClickNext = (event) => {
        this.setState({ ...this.state, showModal: "No, let’s set one up" !== this.state.selectedOption}, () => {
            const { updateCareGapSelectedOption, history, careGapsSessionId } = this.props;
            const { selectedOption } = this.state;
            updateCareGapSelectedOption(selectedOption, constants.AWF);
            logUI(`MBHWeb.UI.AnnualWellnessVisitScreening.Next.Clicked`, new Date(), Tools.getURLPath(), { selectedOption, ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId }) });
            if (selectedOption === "No, let’s set one up") {
                this.setState({ ...this.state, showSpinner: true, clickedOnNext: true }, () => { });
            } else {
                history.push({ pathname: '/schedulemyAnnualWellnessVisit/updatehistory', nextClicked: this.props.history.location?.previousClicked })
            }
        })
    }

    whenOptionLetsSetOneUp = () => {
        this.setState({ ...this.state, showSpinner: false }, () => {
            const { selectedOption, clickedOnNext, userHasEpicAccount, fetchSchedulingPermissionsFailed } = this.state;
            if (userHasEpicAccount && clickedOnNext && selectedOption === 'No, let’s set one up') {
                let path = '';
                const { history, schedulingPermissions: { isOpenSchedulingAvailable, providerNpi, visitTypeId, departmentId, providerFound } } = this.props;
        
                if(isOpenSchedulingAvailable === true && providerFound === true) {
                    path = `/schedule/${providerNpi}/OpenSchedule/${visitTypeId}/${departmentId}`;
                } else if (fetchSchedulingPermissionsFailed === true || !providerFound) {
                    this.redirectToFindCare();
                    return;
                } else {
                    path = `/providers/${providerNpi}`;
                }
        
                history.push({ pathname: path });
            } else if (!userHasEpicAccount && clickedOnNext && selectedOption === 'No, let’s set one up') {
                this.redirectToFindCare();
            }
        });
    }

    redirectToFindCare = () => {
        const { history, careGapsSessionId } = this.props;
        const findcareSearchParms = "?"
        + queryParams({
            keyword: `${encodeURIComponent('Primary Care Provider')}`,
            tab: 2,
            ...(careGapsSessionId && { careGapsSessionId: careGapsSessionId })
        });
        history.push({ pathname: '/findcare', search: findcareSearchParms });
    }

    onFetchSchedulingPermissionsFailed = () => {
        this.setState({ ...this.state, fetchSchedulingPermissionsFailed: true }, () => {
            this.whenOptionLetsSetOneUp();
        });
    }

    fetchSchedulingPermissions = () => {
        const { clickedOnNext } = this.state;
        if (clickedOnNext === true) {
            const {
                memberships,
                getPatientSchedulingPermissions,
                userDetails: { access_token },
                schedulingPermissions: { loadedSchedulingPermissions, isFetching, error }
            } = this.props;

            let epid = memberships.membershipData?.epic?.patient?.PatientIds?.find(pid => pid.IDType === constants.EPI);
                
            if (!loadedSchedulingPermissions && !isFetching && !error) {
                if (epid) {
                    getPatientSchedulingPermissions(
                        access_token,
                        {
                            ProcedureType: constants.AWF,
                            PatientId: epid.ID,
                            PatientIdType: constants.EPI
                        },
                        this.whenOptionLetsSetOneUp,
                        this.onFetchSchedulingPermissionsFailed);
                } else {
                    this.setState({ ...this.state, userHasEpicAccount: false }, () => {
                        this.whenOptionLetsSetOneUp();
                    });
                }
            } else if (loadedSchedulingPermissions === true && (!memberships.membershipData?.epic?.patient ||
                !memberships.membershipData?.epic?.patient?.PatientIds?.length)) {
                this.setState({ ...this.state, userHasEpicAccount: false }, () => {
                    this.whenOptionLetsSetOneUp();
                });
            } else if (!!error) {
                this.onFetchSchedulingPermissionsFailed();
            }
        }
    }
    
    render() {
        const { selectedOption, showModal, showSpinner, clickedOnNext } = this.state;
        const options = ['Yes, I have had one', 'No, let’s set one up', 'I don’t need an annual wellness visit']

        return (
            (showSpinner && clickedOnNext)
            ?
            <>
                <div className="container-fluid body-content">
                    <Spinner />
                </div>
            </>
            :
            <Grid fluid className="body-content body-content--no-top-offset care-gaps-container">
                <div className="row">
                    <div className="col-12 maxWidth-content">
                        <CareGapsHeading
                            heading="Annual wellness visit"
                            description={
                                <>
                                    Our records indicate that you may be due for an annual wellness visit. Let's schedule one or update your health<br />
                                    history so your medical records are up to date.
                                </>
                            }
                        />
                        <CareGapsQuestionHeading question="Have you had an annual wellness visit in the past 12 months?" />

                        <div className="row">
                            <div className="col-lg-8 col-xl-6">
                                <div className="care-gaps-radio-container">
                                    {options && options.map((option, index) => {
                                        return (
                                            <Radio
                                                label={option}
                                                selected={selectedOption}
                                                handleOnclick={this.onChangeValue}
                                                disabled={false}
                                                key={ index}
                                                index={index}
                                                variant="select"
                                                optionsLength={options.length}
                                            />
                                        )
                                    })}
                                </div>

                            </div>
                        </div>

                        <CareGapsButtons
                            prev={{
                                hide: true
                            }}
                            next={{
                                disabled: selectedOption == null,
                                onClick: () => this.handleClickNext()
                            }}
                        />

                    </div>
                </div>
                {showModal && <CareGapsConfirmationModal careGapsType="schedulemyAnnualWellnessVisit" />}
            </Grid>
        );
    }

};

const mapStateToProps = (state) => {
    return {
        selectedCareGapOption: state.careGap.selectedCareGapOption,
        history: state.session.history,
        careGapsSessionId: state.careGap.careGapsSessionId,
        schedulingPermissions: state.careGap.schedulingPermissions,
        userDetails: state.sso.userDetails,
        loadedSchedulingPermissions: state.careGap.schedulingPermissions?.loadedSchedulingPermissions,
        memberships: state.memberships,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        updateCareGapSelectedOption: (selectedOption, procedureType) => dispatch({ type: types.UPDATE_CAREGAP_SELECTED_OPTION, selectedOption, procedureType }),
        clearFlowData: (careGapsSessionId) => { dispatch({ type: types.CLEAR_CAREGAP_DATA_AFTER_ONCHANGE, careGapsSessionId }) },
        saveCareGapsSessionId: (careGapsSessionId) => { dispatch({ type: types.SAVE_CAREGAPS_SESSION_ID, careGapsSessionId }) },
        getPatientSchedulingPermissions: (token, body, successCb, failCb) => dispatch({ type: types.GET_PATIENT_SCHEDULING_PERMISSIONS_START, token, body, successCb, failCb }),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AnnualWellnessVisitScreening);
